import React, { FC } from 'react';
import { connect } from 'react-redux';
import {
    BrowserRouter,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom';

import './assets/styles/App.less';

import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';
import Login from './pages/login';
import { Documents } from './pages/documents';
import { Users } from './pages/users';
import { Sections } from './pages/sections';
import { getRawRoute, RoutePathName } from './routes';
import { isAdmin } from './utils';
import { getUser, CheckLoginStatusState } from './store/actions/auth';
import { MainReducerState } from './store/reducers';
import ResetPassword from './pages/resetPassword';

interface AppProps {
    user: CheckLoginStatusState['user'];
}

const App: FC<AppProps> = ({ user }) => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path={getRawRoute(RoutePathName.login)} component={Login} />
                <Route exact path={getRawRoute(RoutePathName.reset)} component={ResetPassword} />
                <ProtectedRoute loginPath={getRawRoute(RoutePathName.login)}>
                    <MainLayout>
                        <Switch>
                            <Route
                                exact
                                path={getRawRoute(RoutePathName.documents)}
                                component={Documents}
                            />

                            {isAdmin(user) && (
                                <Route
                                    exact
                                    path={getRawRoute(RoutePathName.users)}
                                    component={Users}
                                />
                            )}
                            {isAdmin(user) && (
                                <Route
                                    exact
                                    path={getRawRoute(RoutePathName.sections)}
                                    component={Sections}
                                />
                            )}
                            <Route
                                exact
                                path="/"
                            >
                                <Redirect to={getRawRoute(RoutePathName.documents)} />
                            </Route>

                            <Route>
                                <Redirect to={getRawRoute(RoutePathName.notFound)} />
                            </Route>
                        </Switch>
                    </MainLayout>
                </ProtectedRoute>
            </Switch>
        </BrowserRouter>
    );
};

const mapStateToProps = (state: MainReducerState) => ({
    user: getUser(state),
});

export default connect(
    mapStateToProps,
)(App);
